import Swiperone from "../classes/Swiperone";

export default class SingleEvent {
  constructor(page) {
    this.page = page;
  }

  init() {
    this.initSwipers();
  }

  initSwipers() {
    this._initEventGallery();
    this._initEventsSwiperone();
  }

  _initEventGallery() {
    const swiper = new Swiper(".js-swiper-event-gallery", {
      autoplay: true,
      grabCursor: true,
      disableOnInteraction: true,
      navigation: {
        nextEl: ".js-swiper-gallery-button-next",
        prevEl: ".js-swiper-gallery-button-prev" 
      }
    });
  }

  _initEventsSwiperone() {
    const swiperonies = this.page.querySelectorAll(".js-swiper-events");
    swiperonies?.forEach((swiper) => {
      const swiperone = new Swiperone(swiper, {
          draggable: true,
          pagination: true,
          excerpt: ".js-current-event-desc",
          btnLink: ".js-btn-event-cta"
        }
      );
      swiperone.init();
    });
  }
}